import React from 'react';
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import './BbStory.css';
import '../../Homepage/Welcome/Welcome.css';



const BbStory = () => {
    return (
        <>
            <div
                className="rectangle position-relative"
                style={{ '--background-image': `url(${"https://blueberrywebsites.azureedge.net/bbt/images/WelcomeRectangle.png"})` }}
            >
                <div className="welcome-section meeting-wel-sec container mt-md-5 mt-3 mb-5 pt-md-4">

                    <div className="row">
                        <div className="col-md-12">
                            <h1 className="mt-5 text-center headings meeting-welcome"><span>Our</span> Blueberry Story</h1>
                        </div>
                        <div className='d-flex justify-content-center flex-column align-items-center mt-md-4 mt-2'>
                       <p className='bb-firstP text-center para-color'>Blueberry Travel Pvt. Ltd. was seeded in 2015 and substantially grown with the efforts of all the founders together, making it the world's most reputed and trusted travel agency. This commitment allows us to consistently deliver superior travel experiences to our clients.</p>
                       <p className='bb-secondP text-center para-color'>We have been able to stay on the front lines of the travel industry and give our customers the finest travel experience thanks to a mix of financial stability, investments in people, and cutting-edge technology.</p>
                       <p className='bb-secondP text-center para-color'> Over the past years, Blueberry Travel has expanded its services into various specialized sectors, earning recognition across Africa, Asia, and the Middle East. As a leader in travel and tourism, we provide personalized, world-class experiences to clients and partners in over 30 countries, constantly setting new standards in the industry.</p>
                       <p className='bb-secondP text-center para-color'>Looking forward, we remain committed to pushing the boundaries of what’s possible by offering our clients extraordinary, personalized travel services that exceed expectations every time.</p>
                       <a href="/blog"><button className='bg-transparent border-0 know-more-btn'><span>Know More...</span></button></a>
                       </div>
                    </div>

                    <div className="d-flex justify-content-center mt-2 mb-5">
                    <a href="/blog">
                        <button className="arrow-btn border-0 shadow"> <LazyLoadImage
            effect="blur"
 src="https://blueberrywebsites.azureedge.net/bbt/icons/Right%20arrow.png" alt="right-arrow" loading="lazy"  /></button>
                        </a>
                    </div>
                </div>
            </div>
        </>
    )
}

export default BbStory